/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55546404
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import queryString from 'query-string';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Search from '@components/@core/Search';
import Tab from '@components/@core/Tab';
import * as DocumentCard from '@components/LibraryDocumentCard';
import Status from '@components/LibraryStatus';
import AppActions from '~/actions/app';
import DevelopActions from '~/actions/develop';
import { LibraryDocumentTabs } from '~/services/config';
import withNavigate from '~/hocs/withNavigate';

class DocumentList extends Component {
    constructor(props) {
        super(props);
        const search = props.location?.search || '';
        this.state = {
            active: queryString.parse(search)?.active || 'powerpoint',
            filter: '',
            page: 1,
            perPage: 25,
        };
    }

    componentDidMount() {
        const { active, filter, page, perPage } = this.state;
        this.props.getTemplates(active, { search: filter, page, perPage });
    }

    handleModal = (e) => {
        this.props.toggleModal(e);
    };

    handleToggle = (e, id) => {
        const { active } = this.state;
        const type = e === 'Detail View' ? 'view' : 'edit';
        this.props.navigate(`/library/documents/${active}/${id}/${type}`);
    };

    handleTab = (e) => {
        this.props.getTemplates(e.name, { page: 1, perPage: 25 });
        this.props.navigate(`/library/documents?active=${e.name}`);
        this.setState({ active: e.name, filter: '' });
    };

    handleSearch = (e) => {
        const { active, perPage } = this.state;
        const filter = e.target.value;
        this.props.getTemplates(active, { search: filter, page: 1, perPage });
        this.setState({ filter, page: 1 });
    };

    handlePagination = (page) => {
        const { active, filter, perPage } = this.state;
        this.props.getTemplates(active, { search: filter, page, perPage });
        this.setState({ page });
    };

    handlePer = (perPage) => {
        const { active, filter, page } = this.state;
        this.props.getTemplates(active, { search: filter, page, perPage });
        this.setState({ perPage });
    };

    handleDelete = (id) => {
        const { active, filter } = this.state;
        this.props.deleteDocument({
            id,
            target: active,
            filter: { search: filter, page: 1, per_page: 25 },
        });
    };

    showPreview = (document) => {
        !document?.data.attachment
            ? toast.error("This file doesn't have attachment link", {
                  position: toast.POSITION.TOP_RIGHT,
                  pauseOnFocusLoss: false,
                  hideProgressBar: true,
              })
            : this.props.toggleModal({ type: 'View Document', data: { before: document } });
    };

    showModal = () => {
        const { active } = this.state;
        switch (active) {
            case 'powerpoint':
                this.props.toggleModal({
                    type: 'Add Document',
                    data: { before: { id: 0, name: 'Power Point' } },
                });
                break;
            case 'word':
                this.props.toggleModal({ type: 'Add Document', data: { before: { id: 1, name: 'Word' } } });
                break;
            case 'pdf':
                this.props.toggleModal({ type: 'Add Document', data: { before: { id: 2, name: 'PDF' } } });
                break;
            case 'excel':
                this.props.toggleModal({ type: 'Add Document', data: { before: { id: 3, name: 'Sheet' } } });
                break;
            // case 'envelope':
            //   this.props.toggleModal({ type: 'Add Document', data: { before: { id: 3, name: 'Envelope' } } })
            //   break
            default:
                break;
        }
    };

    render() {
        const { active } = this.state;
        const { templates, isAdmin } = this.props;

        return (
            <ErrorBoundary>
                <Filter add={active} onAdd={this.showModal} />
                <div className="card">
                    <div className="d-h-between">
                        <p className="dsl-b22 bold">Documents</p>
                        <Search onChange={this.handleSearch} />
                    </div>
                    <ResponsiveTabs className="document-tabs" active={active} data={LibraryDocumentTabs} getId={(e) => e['name']} getValue={(e) => e['label']} onTab={this.handleTab} />
                    <Tab eventKey="powerpoint" active={active}>
                        <Status type="Power Points" showToggle counts={templates.powerpoint.total} />
                        <DocumentCard.List
                            isAdmin={isAdmin}
                            iconName="fas fa-file-powerpoint"
                            documentName="PPT"
                            data={templates.powerpoint.data}
                            current={templates.powerpoint.current_page}
                            perPage={templates.powerpoint.per_page}
                            total={templates.powerpoint.last_page}
                            onModal={this.handleModal}
                            onToggle={this.handleToggle}
                            onShow={this.showPreview}
                            onChange={this.handlePagination}
                            onPer={this.handlePer}
                            onDelete={this.handleDelete}
                        />
                    </Tab>
                    <Tab eventKey="word" active={active}>
                        <Status type="Words" showToggle counts={templates.word.total} />
                        <DocumentCard.List
                            isAdmin={isAdmin}
                            iconName="fas fa-file-word"
                            documentName="Word"
                            data={templates.word.data}
                            perPage={templates.word.per_page}
                            current={templates.word.current_page}
                            total={templates.word.last_page}
                            onModal={this.handleModal}
                            onToggle={this.handleToggle}
                            onShow={this.showPreview}
                            onChange={this.handlePagination}
                            onPer={this.handlePer}
                            onDelete={this.handleDelete}
                        />
                    </Tab>
                    <Tab eventKey="pdf" active={active}>
                        <Status type="PDF" showToggle counts={templates.pdf.total} />
                        <DocumentCard.List
                            isAdmin={isAdmin}
                            iconName="fas fa-file-pdf"
                            documentName="PDF"
                            data={templates.pdf.data}
                            perPage={templates.pdf.per_page}
                            current={templates.pdf.current_page}
                            total={templates.pdf.last_page}
                            onModal={this.handleModal}
                            onToggle={this.handleToggle}
                            onShow={this.showPreview}
                            onChange={this.handlePagination}
                            onPer={this.handlePer}
                            onDelete={this.handleDelete}
                        />
                    </Tab>
                    <Tab eventKey="esign" active={active}>
                        <Status type="eSign" showToggle counts={templates.esign.total} />
                        <DocumentCard.List
                            isAdmin={isAdmin}
                            iconName="fas fa-at"
                            documentName="eSign"
                            data={templates.esign.data}
                            perPage={templates.esign.per_page}
                            current={templates.esign.current_page}
                            total={templates.esign.last_page}
                            onModal={this.handleModal}
                            onToggle={this.handleToggle}
                            onShow={this.showPreview}
                            onChange={this.handlePagination}
                            onPer={this.handlePer}
                            onDelete={this.handleDelete}
                        />
                    </Tab>
                    {/* Hiding envelope for now [TOP-2430]  */}
                    {/* <Tab eventKey="envelope" active={active}>
             <Status type="Envelopes" showToggle counts={templates.envelope.total} />
             <DocumentCard.List
               iconName="fas fa-envelope-open-text"
               documentName="Envelope"
               data={templates.envelope.data}
               perPage={templates.envelope.per_page}
               current={templates.envelope.current_page}
               total={templates.envelope.last_page}
               onToggle={this.handleToggle}
               onShow={this.showPreview}
               onChange={this.handlePagination}
             />
           </Tab> */}
                    <Tab eventKey="packets" active={active}>
                        <Status type="Packets" showToggle counts={templates.packets.total} />
                        <DocumentCard.List
                            isAdmin={isAdmin}
                            iconName="fas fa-envelope-open-text"
                            documentName="Packet"
                            data={templates.packets.data}
                            perPage={templates.packets.per_page}
                            current={templates.packets.current_page}
                            total={templates.packets.last_page}
                            onModal={this.handleModal}
                            onToggle={this.handleToggle}
                            onShow={this.showPreview}
                            onChange={this.handlePagination}
                            onPer={this.handlePer}
                            onDelete={this.handleDelete}
                        />
                    </Tab>
                    <Tab eventKey="excel" active={active}>
                        <Status type="Excel" showToggle counts={templates.packets.total} />
                        <DocumentCard.List
                            isAdmin={isAdmin}
                            iconName="fas fa-file-excel"
                            documentName="Excel"
                            data={templates.excel.data}
                            perPage={templates.excel.per_page}
                            current={templates.excel.current_page}
                            total={templates.excel.last_page}
                            onModal={this.handleModal}
                            onToggle={this.handleToggle}
                            onShow={this.showPreview}
                            onChange={this.handlePagination}
                            onPer={this.handlePer}
                            onDelete={this.handleDelete}
                        />
                    </Tab>
                </div>
            </ErrorBoundary>
        );
    }
}

DocumentList.propTypes = {
    isAdmin: PropTypes.bool,
    templates: PropTypes.any,
    modalData: PropTypes.any,
    getTemplates: PropTypes.func,
    deleteDocument: PropTypes.func,
    toggleModal: PropTypes.func,
};

DocumentList.defaultProps = {
    isAdmin: false,
    templates: {},
    modalData: {},
    getTemplates: () => {},
    deleteDocument: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    isAdmin: state.app.app_role_id < 3,
    templates: state.develop.templates,
    modalData: state.app.modalData.after,
});

const mapDispatchToProps = (dispatch) => ({
    getTemplates: (target, payload) => dispatch(DevelopActions.getlibrarytemplatessearchRequest(target, payload)),
    deleteDocument: (payload) => dispatch(DevelopActions.deletedocumentRequest(payload)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const DocumentListWithNavigate = withNavigate(DocumentList);

export default connect(mapStateToProps, mapDispatchToProps)(DocumentListWithNavigate);
